/**
 * Ask Human Button Component
 * Button to trigger the Ask Human modal for posting to communities
 */

import '../../../../styles/oc-utilities.css';

import React from 'react';

import { StyledButton } from './AskHumanButton.styled';

export type AskHumanButtonProps = {
  onClick: () => void;
  disabled?: boolean;
  text?: string;
  className?: string;
};

/**
 * AskHumanButton Component
 * Displays a button that opens the Ask Human modal
 */
const AskHumanButton: React.FC<AskHumanButtonProps> = ({
  onClick,
  disabled = false,
  text = 'Ask your fellow humans',
  className = '',
}) => {
  return (
    <StyledButton
      type="button"
      onClick={onClick}
      disabled={disabled}
      $disabled={disabled}
      className={className}
      aria-label={disabled ? 'Start a chat session first' : text}
    >
      <span className="ai-button-text">{text}</span>
    </StyledButton>
  );
};

export default React.memo(AskHumanButton);
